import React from 'react';
import history from 'app/routes/history';
import _ from 'lodash';
import classnames from 'classnames';
import base64 from 'base-64';

import Isvg from 'react-inlinesvg';
import Button from 'app/components/general/Button';
import BadgeWithTooltip from 'app/components/general/BadgeWithTooltip';
import {
  Card,
  CardBody,
  ButtonGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';

import SectionIcon from 'app/images/icons/section.svg';
import TimeIcon from 'app/images/icons/time.svg';
import LocationIcon from 'app/images/icons/location.svg';
import InfoIcon from 'app/images/icons/info.svg';

interface IPaymentCardProps {
  matchPaymentId: string;
  forfeitId: string;
  paymentEventId: string;
  groupId: string;
  round: string;
  dateTime: string;
  syncedAt: string;
  eventInfo: string;
  amount: string;
  paymentEnabled: boolean;
  section: string;
  time: string;
  timeRaw: string;
  location: string;
  status: string;
  statusBlock: any;
  matchStatus: string;
  otherTeamStatus: string;
  otherTeamStatusBlock: any;
  statuses: [
    {
      colour: string;
      text: string;
      description: string;
    }
  ];
  truncated: boolean;
  truncatedButtons: boolean;
  mainButton: boolean;
  payButtonEnabled: boolean;
  paymentCategory: string;
  metadata: any;
}

interface IPaymentCardState {
  tooltipOpen: false;
}
export default class PaymentCard extends React.Component<
  IPaymentCardProps,
  IPaymentCardState
  > {
  static defaultProps: IPaymentCardProps = {
    matchPaymentId: undefined,
    forfeitId: undefined,
    paymentEventId: undefined,
    groupId: undefined,
    round: undefined,
    dateTime: undefined,
    syncedAt: undefined,
    eventInfo: undefined,
    amount: undefined,
    section: undefined,
    time: undefined,
    location: undefined,
    statuses: undefined,
    status: undefined,
    statusBlock: undefined,
    otherTeamStatus: undefined,
    otherTeamStatusBlock: undefined,
    matchStatus: undefined,
    truncated: false,
    truncatedButtons: false,
    mainButton: false,
    paymentEnabled: true,
    payButtonEnabled: true,
    paymentCategory: 'event',
    metadata: {},
  };

  state: IPaymentCardState = {
    tooltipOpen: false,
  };

  toggleTooltip = (e) => {
    e.preventDefault()
    this.setState((previousState) => ({
      tooltipOpen: !previousState.tooltipOpen,
    }));
  };

  closeTooltip = () => {
    this.setState({ tooltipOpen: false });
  };

  renderBadge = (): React.ReactNode => _.map(this.props.statuses, (status) => {
    const targetId = `t-${this.props.paymentEventId}`

    return (<BadgeWithTooltip className="payment-badge" targetId={targetId} key={status.text} color={status.colour} tooltipText={status.description}>
      {status.text}
    </BadgeWithTooltip>
    )
  });

  renderPopover = (): React.ReactNode => {
    const targetId = `info-${this.props.paymentEventId}`
    const elementExists = document.getElementById(targetId);
    if (elementExists) {
      return (
        <Popover
          placement="bottom"
          isOpen={this.state.tooltipOpen}
          target={targetId}
          onClick={this.closeTooltip}
          toggle={this.toggleTooltip}
        >
          <PopoverHeader>Fixture info</PopoverHeader>
          <PopoverBody>
            {!_.isEmpty(this.props.syncedAt) && (
              <span className="text-weight-medium-bold">
                Last synced:
                {' '}
                {this.props.syncedAt}
                {' '}
                <br />
              </span>
            )}
            <p>
              Please refer to your regular fixture for the most up-to-date
              information. We pull the fixture data regularly, however it may not
              always be the same.
        </p>
            <p>
              Please only contact
          {' '}
              <a href="mailto:support@teammo.com.au">support@teammo.com.au</a>
              {' '}
          if
          the team you're playing is different to the one listed in Teammo.
          Differences to location/time will not cause any problems with your
          payment.
        </p>
          </PopoverBody>
        </Popover>
      )
    } else {
      return null;
    }
  };

  render(): React.ReactNode {
    const payButtonEnabled = this.props.paymentEnabled === undefined ? true : this.props.paymentEnabled
    const payRequestPreconfigData = base64.encode(JSON.stringify({
      description: this.props.round,
      amount: this.props.amount,
      dueDate: this.props.timeRaw,
      matchPaymentId: this.props.matchPaymentId,
      paymentEventId: this.props.paymentEventId,
      groupId: this.props.groupId,
    }))
    return (
      <div className="row">
        <div className="col col-12">
          <Card className="payment-card extra-radius">
            <CardBody className="with-padding">              
              <div className="row">
                <div className="col col-12 col-md-6">
                  {!this.props.truncated && (
                    <div className="row with-margin-bottom">
                      <div className="col">
                        <div className="payment-badge-group">
                          {this.renderBadge()}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col">
                      <span className="text-weight-medium">
                        {this.props.round}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col with-margin-top-10">
                      <h2>{this.props.dateTime}</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <span className="">
                        {this.props.eventInfo}
                      </span>
                    </div>
                  </div>
                  {!this.props.truncated
                    && this.props.paymentCategory !== 'event-variable'
                    && this.props.statusBlock.forfeitStatus !== 'walkover' && (
                      <div className="row">
                        <div className="col with-margin-top">
                          <span className="payment-card-amount">
                            {this.props.amount}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
                <div className="col col-12 col-md-6 extra-info">
                  <div className="d-flex flex-column justify-content-center align-items-start h-100">
                    <div className="row">
                      <div className="col">
                        <div className="payment-card-caption-row">
                          <Isvg
                            className="payment-card-icon"
                            src={SectionIcon}
                          />
                          <span className="caption-text">
                            {this.props.section}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="payment-card-caption-row">
                          <Isvg className="payment-card-icon" src={TimeIcon} />
                          <span className="caption-text">
                            {this.props.time}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="payment-card-caption-row no-margin-bottom">
                          <Isvg
                            className="payment-card-icon"
                            src={LocationIcon}
                          />
                          <span className="caption-text">
                            {this.props.location}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id={`info-${this.props.paymentEventId}`}
                className="payment-card-info-icon"
                onClick={this.toggleTooltip}
              >
                <Isvg src={InfoIcon} />
              </div>
              {this.renderPopover()}
            </CardBody>
            {!(this.props.truncated || this.props.truncatedButtons) && (
              <div className="row">
                <ButtonGroup className="w-100 payment-card-btns with-padding-15 uniform-radius">
                  {_.includes(['pending'], this.props.statusBlock.paymentStatus)
                  && payButtonEnabled
                    && !_.includes(['walkover'], this.props.statusBlock.forfeitStatus)
                    && !_.includes(['cancelled', 'paused'], this.props.matchStatus)
                    && !_.includes(['no-show'], this.props.statusBlock.adminStatus)
                    && !_.includes(['walkover'], this.props.otherTeamStatusBlock.forfeitStatus) && (
                      <Button
                      className={classnames({ 'btn-1': this.props.mainButton }, { 'btn-2': !this.props.mainButton })}
                        onClick={() => history.push(
                          `/payment/match/${this.props.matchPaymentId}/review`,
                        )}
                      >
                        Pay Now
                      </Button>
                    )}
                  {_.includes(
                    ['paid', 'paid-cash', 'paid-eftpos'],
                    this.props.statusBlock.paymentStatus,
                  ) && (
                      <Button
                        className="btn-1"
                      onClick={() => history.push(`/payment-requests/new:${payRequestPreconfigData}`)}
                      >
                        Collect from Team
                      </Button>
                    )}
                  {_.includes(
                    ['pending'],
                    this.props.statusBlock.paymentStatus,
                  ) && (
                      <Button
                        className="btn-2"
                        onClick={() => history.push(`/payment-requests/new:${payRequestPreconfigData}`)}
                      >
                        Collect from Team
                      </Button>
                    )}
                  {_.includes(
                    ['pending', 'paid', 'paid-cash', 'paid-eftpos', 'paid-transferred', 'paid-refunded', 'paid-prepaid'],
                    this.props.statusBlock.paymentStatus,
                  )
                    && !_.includes(['walkover'], this.props.statusBlock.forfeitStatus)
                    && !_.includes(['walkover'], this.props.otherTeamStatusBlock.forfeitStatus) && !_.includes(['cancelled', 'paused'], this.props.matchStatus) && (
                      <Button
                      className="btn-2"
                        onClick={() => history.push(
                          `/forfeit/${this.props.paymentEventId}/${this.props.groupId}/submit`,
                        )}
                      >
                        Submit Forfeit
                      </Button>
                    )}
                  {_.includes(['paid'], this.props.statusBlock.paymentStatus) && !_.includes(['walkover'], this.props.statusBlock.forfeitStatus) && (
                    <Button
                      className="btn-2"
                      onClick={() => history.push(
                        `/payment/match/${this.props.matchPaymentId}/receipt`,
                      )}
                    >
                      View Receipt
                    </Button>
                  )}
                  {_.includes(['walkover'], this.props.statusBlock.forfeitStatus) && (
                    <Button
                      className="btn-2"
                      onClick={() => history.push(
                        `/payment/forfeit/${this.props.forfeitId}/receipt`,
                      )}
                    >
                      View Receipt
                    </Button>
                  )}
                </ButtonGroup>
              </div>
            )}
          </Card>
        </div>
      </div>
    );
  }
}
